/**
 * Created by Jerker Nord on 2021-01-27.
 */
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {TheBorderGameAssets} from "../TheBorderGameAssets";
import {TheBorder} from "../TheBorder";
import {TheBorderGameMode} from "../server/TheBorderGameMode";
import {TimelineLite} from "gsap";
import {SpineTween} from "@nolimitcity/slot-game/bin/animation/SpineTween";

export class TheBorderBackgroundElements extends PIXI.Container implements StageLayer {

    private _backgroundContainer: PIXI.Container;
    private _backgroundMain: PIXI.Sprite;
    private _mainView: PIXI.Container;
    private _backgroundFS: PIXI.Sprite;
    private _backgroundSuperFS: PIXI.Sprite;
    private _bgAnim: PIXI.spine.Spine;
    private _bgAnimName: string = "";
    private _bgAnimTl: TimelineLite;

    constructor() {
        super();
        this.name = "TheBorderBackgroundElements";
        this.init();
    }

    public setMode(mode: string): void {
        if (mode == TheBorderGameMode.FREESPIN || mode == TheBorderGameMode.FREESPIN_AVALANCHE) {
            this.swapBackgroundTo(this._backgroundFS);

            this.clearBgAnim();
        } else if (mode == TheBorderGameMode.SUPER_FREESPIN || mode == TheBorderGameMode.SUPER_FREESPIN_AVALANCHE) {
            this.swapBackgroundTo(this._backgroundSuperFS);

            this.clearBgAnim();
        } else {
            this.swapBackgroundTo(this._backgroundMain);

            this.playBackgroundAnim("idle", -1);
        }
    }

    // #346
    public playBackgroundAnim(name: string, loopCount: number): void {
        if (this._bgAnimTl) {
            this._bgAnimTl.pause();
            this._bgAnimTl.kill();
        }

        if (this._bgAnimName === name || (this._bgAnimName === "in_idle" && name === "in")) {
            return;
        }

        this._bgAnimTl = new TimelineLite();

        if (this._bgAnimName === "in_idle") {
            this._bgAnimTl.add(() => {
                this.resetSpine();
            });
            this._bgAnimTl.add(new SpineTween(this._bgAnim, 0, "out"));
        }

        if (name === "in") {
            this._bgAnimTl.add(() => {
                this.resetSpine();
            });
            this._bgAnimTl.add(new SpineTween(this._bgAnim, 0, name));
            name = "in_idle";
            loopCount = -1;
        }

        this._bgAnimTl.add(() => {
            this.resetSpine();
        });
        this._bgAnimTl.add(new SpineTween(this._bgAnim, 0, name, loopCount));

        this._bgAnimName = name;
    }

    private init(): void {
        this._mainView = new PIXI.Container();
        this._backgroundContainer = new PIXI.Container();

        this._backgroundMain = new PIXI.Sprite(TheBorder.assetLoader.getTextures(TheBorderGameAssets.MAIN_GAME_BACKGROUND)[0]);
        this._backgroundMain.position.set(360, 360);
        this._backgroundMain.anchor.set(0.5, 0.5);

        this._backgroundFS = new PIXI.Sprite(TheBorder.assetLoader.getTextures(TheBorderGameAssets.FS_BACKGROUND)[0]);
        this._backgroundFS.position.set(360, 360);
        this._backgroundFS.anchor.set(0.5, 0.5);

        this._backgroundSuperFS = new PIXI.Sprite(TheBorder.assetLoader.getTextures(TheBorderGameAssets.SUPER_FS_BACKGROUND)[0]);
        this._backgroundSuperFS.position.set(360, 360);
        this._backgroundSuperFS.anchor.set(0.5, 0.5);

        this._backgroundContainer.addChild(this._backgroundMain);
        this._backgroundContainer.position.set(0, 0);

        this._bgAnim = new PIXI.spine.Spine(TheBorder.assetLoader.getSpineAsset(TheBorderGameAssets.BG_ANIM));
        this._bgAnim.visible = false;
        this._bgAnim.position.set(360);

        this._mainView.addChild(this._backgroundContainer, this._bgAnim);
        this.addChild(this._mainView);
    }

    private swapBackgroundTo(newBackground: PIXI.Sprite): void {
        this._backgroundContainer.addChildAt(newBackground, 0);
        if (this._backgroundContainer.children.length > 1) {
            this._backgroundContainer.removeChildren(1);
        }
    }

    private resetSpine(): void {
        if (!this._bgAnim.visible) {
            this._bgAnim.visible = true;
            this._bgAnim.updateTransform();
        }
        this._bgAnim.state.clearTracks();
        this._bgAnim.skeleton.setSlotsToSetupPose();
        this._bgAnim.skeleton.setToSetupPose();
        this._bgAnim.state.setEmptyAnimation(0, 0);
    }

    private clearBgAnim(): void {
        this._bgAnim.state.clearTracks();
        this._bgAnim.visible = false;

        if (this._bgAnimTl) {
            this._bgAnimTl.pause();
            this._bgAnimTl.kill();
        }

        this._bgAnimName = "";
    }
}